module.exports = __webpack_public_path__ + "img/cy.170c71c5.svg";